<template lang="pug">
  accordion.paddingBottom.eventsList(:injected="injected", container="#body", :thresold=50, ref='accordion', :sort-by="['event.startTime']")
    template(v-if='eventsListStatus == STATUS.LOADED && eventsListCanLoadPrevious')
      accordion-loading-header.inPast(@fire='loadPrevious', :thresold="40", @click="loadPrevious") {{$t("events.loadingPrevious")}}
        span(v-if='eventsList.length > 0') &nbsp; ({{$t("events.loadedUntil")}} {{eventsList[0].startTimeStr}})
    template(v-if='eventsListStatus == STATUS.LOADED && !eventsListCanLoadPrevious')
      .information-message {{$t("events.allPreviousLoaded")}}
    accordion-loading-header.afterHeaderMargin(v-if='eventsListStatus == STATUS.LOADING', @fire='doNothing') {{$t("events.loading")}}
    template(v-if='eventsListStatus == STATUS.LOADED')
      template(v-if='eventsList.length == 0') 
        h2
          small {{$t("events.noEvents")}}
        i.fa.fa-hand-pointer-o.plusPointer
      template(v-else)
        template(v-for='(monthAndEvents, index) in eventsByMonth')
          hr(v-if='monthAndEvents.now && index != 0')
          accordion-subtitle(group='monthHeader')
            template(v-if='monthAndEvents.nearly')
              | {{ $t('events.nearly.' + monthAndEvents.month) }}
            template(v-else)
              | {{ monthAndEvents.elems[0].startTime * 1000 | monthYear | ucfirst }}
          detailled-event(v-for='event in monthAndEvents.elems', :event='event', :initial-active='active', :initial-stay-active='stayActive', :injected='injected', :key="event.id", @asktoclose="removeEvent(event)")
      template(v-if='eventsListCanLoadMore')
        h2
        accordion-loading-header(@fire='loadNext') {{$t("events.loadingNext")}}
      template(v-else)
        h2 
        .information-message {{$t("events.allNextLoaded")}}
</template>
<script>
import {mapGetters} from 'vuex'
import $ from 'jquery'
import STATUS from '@/utils/status'
import _ from 'lodash'
import moment from 'moment'

import Accordion from '@/components/shared/Accordion/Accordion'
import AccordionItem from '@/components/shared/Accordion/Accordion-Item'
import AccordionSubtitle from '@/components/shared/Accordion/Accordion-Subtitle'
import AccordionLoadingHeader from '@/components/shared/Accordion/Accordion-LoadingHeader'

import DetailledEvent from './DetailledEvent'

import MousetrapManager from '@/components/shared/mousetrapManager'

// import HelpTip from '@/tools/helptip/helptip'

export default {
  props: {
    injected: {
      type: Boolean,
      default: false
    },
    eventsBus: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    stayActive: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      loaded: false,
      loading: true,
      loadingMore: false,
      loadingMorePrevious: false,
      STATUS
    }
  },
  components: {
    DetailledEvent,
    AccordionLoadingHeader,
    AccordionSubtitle,
    AccordionItem,
    Accordion
  },
  computed: {
    ...mapGetters('groops', [
      'selectedGroops'
    ]),
    ...mapGetters('user', [
      'user'
    ]),
    ...mapGetters('events', [
      'eventsList',
      'eventsListStatus',
      'eventsListCanLoadMore',
      'eventsListCanLoadPrevious'
    ]),
    ...mapGetters('search', [
      'searchObject',
      'searchKeyedValues'
    ]),
    eventsByMonth () {
      // var answer, canShowIt, event, flatMonths, month, months, regex, text, _i, _j, _len, _len1, _ref, _ref1
      this.eventsList.sort(function (a, b) {
        if (a.startTime < b.startTime) {
          return -1
        }
        if (a.startTime > b.startTime) {
          return 1
        }
        if (a.endTime < b.endTime) {
          return -1
        }
        if (a.endTime > b.endTime) {
          return 1
        }
        if (a.id < b.id) {
          return -1
        }
        if (a.id > b.id) {
          return 1
        }
        return 0
      })
      let months = []
      let flatMonths = []
      let _ref = this.eventsList
      let now = 0
      for (let _i = 0, _len = _ref.length; _i < _len; _i++) {
        let event = _ref[_i]
        let answer = event.answers[this.user.id]
        let answers = this.searchKeyedValues('answers')
        if (answers.length > 0) {
          let canShowIt = false
          if (answers.indexOf('none') > -1) {
            if (answer.answer == null) {
              canShowIt = true
            }
          }
          if (answers.indexOf('yes') > -1) {
            if (answer.answer === 'Yes') {
              canShowIt = true
            }
          }
          if (answers.indexOf('no') > -1) {
            if (answer.answer === 'No') {
              canShowIt = true
            }
          }
          if (answers.indexOf('maybe') > -1) {
            if (answer.answer === 'Maybe') {
              canShowIt = true
            }
          }
          if (!canShowIt) {
            continue
          }
        }
        if (this.searchObject.texts.length > 0) {
          let canShowIt = false
          let _ref1 = this.searchObject.texts
          for (let _j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
            let text = _ref1[_j]
            let regex = new RegExp('.*' + _.escapeRegExp(text) + '.*', 'i')
            if (regex.test(event.city) || regex.test(event.country) || regex.test(event.name) || regex.test(event.type) || regex.test(event.description)) {
              canShowIt = true
            }
          }
          if (!canShowIt) {
            continue
          }
        }
        let nearly = false
        let month = moment.unix(event.startTime).format('YYYY/MM')
        if (moment.unix(event.startTime).startOf('day').isBefore(moment().startOf('day'))) {
        } else {
          now++
          if (moment.unix(event.startTime).startOf('day').isSame(moment().startOf('day'))) {
            month = 'today'
            nearly = true
          } else if (moment.unix(event.startTime).startOf('day').isSame(moment().add(1, 'day').startOf('day'))) {
            month = 'tomorrow'
            nearly = true
          } else if (moment.unix(event.startTime).startOf('day').diff(moment().startOf('day'), 'days') < 7) {
            month = 'day' + moment.unix(event.startTime).day()
            nearly = true
          } else {
            if (moment.unix(event.startTime).month() === moment().month() && moment.unix(event.startTime).year() === moment().year()) {
              month = 'thisMonth'
              nearly = true
            }
          }
        }
        if (months[month] == null) {
          months[month] = {
            elems: [],
            month: month,
            nearly: nearly,
            now: now === 1,
            past: now === 0
          }
          flatMonths.push(months[month])
        }
        months[month].elems.push(event)
      }
      return flatMonths
    }
  },
  mounted () {
    this.scrollToStart()
    this.eventsBus.$on(this.eventsBus.CLICK_ON_SIDEBAR, (data) => {
      this.$store.dispatch('events/cleanEventsList')
      this.$store.dispatch('events/loadEventsList', {groops: this.selectedGroops})
      this.scrollToStart()
    })
    this.eventsBus.$on(this.eventsBus.NEW_EVENT, (data) => {
      this.$store.dispatch('events/updateList', data.events)
    })
    this.eventsBus.$on(this.eventsBus.NEW_EVENTS, (data) => {
      this.$store.dispatch('events/cleanEventsList')
      this.$store.dispatch('events/loadEventsList', {groops: this.selectedGroops})
    })
    this.eventsBus.$on(this.eventsBus.DELETED_EVENT, (data) => {
      this.$store.dispatch('events/removeEventFromEventsList', data.event)
    })
    this.$store.dispatch('events/loadEventsList', {groops: this.selectedGroops})
    MousetrapManager.bindAll({
      'k': () => { this.$refs.accordion.selectPreviousItem() },
      'j': () => { this.$refs.accordion.selectNextItem() },
      'space': () => { this.$refs.accordion.toggleActiveItem(); return false },
      'y': () => {
        let event = this.$refs.accordion.getLastSelectedItem().$parent.event
        this.$store.dispatch('events/putEventAnswer', {event: event, answer: 'Yes', user: this.user})
      },
      'n': () => {
        let event = this.$refs.accordion.getLastSelectedItem().$parent.event
        this.$store.dispatch('events/putEventAnswer', {event: event, answer: 'No', user: this.user})
      },
      '?': () => {
        let event = this.$refs.accordion.getLastSelectedItem().$parent.event
        this.$store.dispatch('events/putEventAnswer', {event: event, answer: 'Maybe', user: this.user})
      },
      '/': () => {
        let event = this.$refs.accordion.getLastSelectedItem().$parent.event
        this.$store.dispatch('events/putEventAnswer', {event: event, answer: null, user: this.user})
      }
    }, 'Events-List')
  },
  destroyed () {
    this.$store.dispatch('events/cleanEventsList')
    MousetrapManager.unbindLabel('Events-List')
  },
  methods: {
    doNothing () {},
    scrollToStart () {
      this.$nextTick(() => {
        $('#body').scrollTop(70)
        $(window).trigger('scroll')
      })
    },
    loadPrevious () {
      if (this.loadingMorePrevious) {
        return
      }
      this.loadingMorePrevious = true
      let innerHeight = $('#body')[0].scrollHeight
      this.$store.dispatch('events/loadMorePreviousEventsList', {groops: this.selectedGroops}).then(() => {
        this.$nextTick(() => {
          let delta = $('#body')[0].scrollHeight - innerHeight
          $('#body')[0].scrollTop = $('#body')[0].scrollTop + delta
          this.loadingMorePrevious = false
        })
      }).catch(() => {
      })
    },
    loadNext () {
      if (this.loadingMore) {
        return
      }
      this.loadingMore = true
      this.$store.dispatch('events/loadMoreEventsList', {groops: this.selectedGroops}).then(() => {
        this.loadingMore = false
      }).catch(() => {
      })
    }
  },
  filters: {
    ucfirst: (value) => _.upperFirst(value),
    monthYear (value) {
      let date = moment(value)
      return date.format('MMMM YYYY')
    }
  },
  watch: {
    selectedGroops () {
      this.$store.dispatch('events/cleanEventsList').then(() => {
        this.scrollToStart()
        this.$store.dispatch('events/loadEventsList', {groops: this.selectedGroops})
      })
    },
    eventsList () {
      this.$nextTick(() => {
        this.$refs.accordion.adjustFixedElements()
        // if (arguments) {
        //   return
        // }
        // new HelpTip({
        //   name: 'clignote',
        //   el: '.needOwnAnswer .answers.pull-right .fa-user',
        //   contents: 'Les événements auxquels vous devez répondre clignotent.',
        //   delay: 0,
        //   radius: '50%',
        //   margin: 50
        // }).show()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Events-List.vue?37d70e52